import { identity } from 'lodash-es';
import { FETCH_DATA_REQUEST, FETCH_DATA_SUCCESS, FETCH_DATA_FAILED } from './actionTypes';
import api from '../api';

export const fetchDataByAsset =
  (
    assetName,
    assetFilters = {},
    {
      cancelToken = null,
      transformResponse,
      decorateRequestParams = identity,
      decorateRequestAction = identity,
      decorateSuccessAction = identity,
      onSuccess,
    } = {}
  ) =>
  (dispatch, getState) => {
    const { aiDashboard } = getState();

    const requestFilters = {
      ...(aiDashboard[assetName].filters || {}),
      ...assetFilters,
    };

    const requestParams = decorateRequestParams({
      params: {
        asset: assetName,
        filters: requestFilters,
      },
      ...(cancelToken ? { cancelToken } : {}),
    });

    dispatch(
      decorateRequestAction({
        type: FETCH_DATA_REQUEST,
        assetName,
      })
    );

    api
      .fetchAiDashboardData(requestParams)
      .then(({ data }) => {
        const responseData = transformResponse ? transformResponse(data) : data;

        dispatch(
          decorateSuccessAction({
            type: FETCH_DATA_SUCCESS,
            assetName,
            data: responseData.data,
            filters: responseData.filters,
          })
        );

        if (onSuccess) onSuccess(responseData);
      })
      .catch((error) => {
        if (!api.isCancelRequest(error)) {
          dispatch({
            type: FETCH_DATA_FAILED,
            assetName,
            error: error.response,
          });
        }
      });
  };
